var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 965.87,
    height: 292.07,
    viewBox: "0 0 965.87 292.07",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m0,105.88h38.4c10.75,0,19.87,1.31,27.35,3.95,7.48,2.63,13.7,5.99,18.67,10.08,4.97,4.09,8.88,8.62,11.75,13.59,2.86,4.97,4.97,9.73,6.31,14.29,1.34,4.56,2.19,8.68,2.54,12.36.35,3.68.53,6.29.53,7.8s-.17,4.12-.53,7.8c-.35,3.68-1.2,7.8-2.54,12.36-1.34,4.56-3.45,9.32-6.31,14.29-2.87,4.97-6.78,9.5-11.75,13.59-4.97,4.09-11.19,7.45-18.67,10.08-7.48,2.63-16.6,3.95-27.35,3.95H0v-124.14Zm11.57,113.62h23.85c8.18,0,15.84-1.02,22.97-3.07,7.13-2.04,13.33-5.17,18.59-9.38,5.26-4.21,9.41-9.56,12.45-16.04,3.04-6.49,4.56-14.17,4.56-23.06s-1.52-16.57-4.56-23.06c-3.04-6.49-7.19-11.83-12.45-16.04-5.26-4.21-11.46-7.33-18.59-9.38-7.13-2.04-14.79-3.07-22.97-3.07H11.57v103.1Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m159.82,105.88h11.92l52.25,124.14h-12.97l-13.5-32.96h-65.75l-14.03,32.96h-12.1l54.18-124.14Zm5.44,12.62l-28.93,68.03h56.98l-28.05-68.03Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m236.12,149.01h10.52v14.2h.35c1.64-2.8,3.68-5.23,6.14-7.28,2.46-2.04,5.11-3.74,7.98-5.08,2.86-1.34,5.87-2.34,9.03-2.98,3.16-.64,6.25-.96,9.29-.96,6.19,0,11.89,1.05,17.09,3.16,5.2,2.1,9.7,5.06,13.5,8.85,3.8,3.8,6.75,8.3,8.85,13.5,2.1,5.2,3.16,10.9,3.16,17.1s-1.05,11.9-3.16,17.09c-2.1,5.2-5.06,9.7-8.85,13.5s-8.3,6.75-13.5,8.85c-5.2,2.1-10.9,3.16-17.09,3.16-3.04,0-6.14-.32-9.29-.96-3.16-.64-6.17-1.64-9.03-2.98-2.87-1.34-5.52-3.04-7.98-5.08-2.45-2.04-4.5-4.47-6.14-7.28h-.35v54.18h-10.52v-120.98Zm9.47,40.5c0,4.56.88,8.85,2.63,12.89,1.75,4.03,4.15,7.54,7.19,10.52,3.04,2.98,6.6,5.35,10.7,7.1,4.09,1.75,8.53,2.63,13.33,2.63s9.35-.88,13.33-2.63c3.97-1.75,7.36-4.12,10.17-7.1,2.81-2.98,4.94-6.49,6.4-10.52,1.46-4.03,2.19-8.33,2.19-12.89s-.73-8.85-2.19-12.89c-1.46-4.03-3.59-7.54-6.4-10.52-2.8-2.98-6.2-5.35-10.17-7.1-3.98-1.75-8.42-2.63-13.33-2.63s-9.24.88-13.33,2.63c-4.09,1.75-7.66,4.12-10.7,7.1-3.04,2.98-5.44,6.49-7.19,10.52-1.75,4.03-2.63,8.33-2.63,12.89Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m340.73,149.01h10.52v14.2h.35c1.64-2.8,3.68-5.23,6.14-7.28,2.45-2.04,5.11-3.74,7.98-5.08,2.86-1.34,5.87-2.34,9.03-2.98,3.16-.64,6.25-.96,9.29-.96,6.19,0,11.89,1.05,17.1,3.16,5.2,2.1,9.7,5.06,13.5,8.85,3.8,3.8,6.75,8.3,8.85,13.5,2.1,5.2,3.16,10.9,3.16,17.1s-1.05,11.9-3.16,17.09c-2.1,5.2-5.06,9.7-8.85,13.5-3.8,3.8-8.3,6.75-13.5,8.85-5.2,2.1-10.9,3.16-17.1,3.16-3.04,0-6.14-.32-9.29-.96-3.16-.64-6.17-1.64-9.03-2.98-2.87-1.34-5.52-3.04-7.98-5.08-2.46-2.04-4.5-4.47-6.14-7.28h-.35v54.18h-10.52v-120.98Zm9.47,40.5c0,4.56.88,8.85,2.63,12.89,1.75,4.03,4.15,7.54,7.19,10.52,3.04,2.98,6.6,5.35,10.7,7.1,4.09,1.75,8.53,2.63,13.33,2.63s9.35-.88,13.33-2.63c3.97-1.75,7.36-4.12,10.17-7.1,2.81-2.98,4.94-6.49,6.4-10.52,1.46-4.03,2.19-8.33,2.19-12.89s-.73-8.85-2.19-12.89c-1.46-4.03-3.59-7.54-6.4-10.52s-6.2-5.35-10.17-7.1c-3.97-1.75-8.42-2.63-13.33-2.63s-9.24.88-13.33,2.63c-4.09,1.75-7.66,4.12-10.7,7.1-3.04,2.98-5.44,6.49-7.19,10.52-1.75,4.03-2.63,8.33-2.63,12.89Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m552.23,221.95c-7.25,4.09-14.76,6.99-22.53,8.68-7.77,1.69-15.69,2.54-23.76,2.54-9.47,0-18.15-1.61-26.04-4.82-7.89-3.21-14.64-7.71-20.25-13.5-5.61-5.79-9.99-12.68-13.15-20.69-3.16-8.01-4.73-16.75-4.73-26.21s1.58-18.17,4.73-26.12c3.16-7.95,7.54-14.82,13.15-20.6,5.61-5.79,12.36-10.31,20.25-13.59,7.89-3.27,16.57-4.91,26.04-4.91,18.47,0,33.37,5.73,44.71,17.18l-8.42,8.77c-1.87-2.22-4.18-4.29-6.93-6.22-2.75-1.93-5.73-3.56-8.94-4.91-3.22-1.34-6.58-2.39-10.08-3.16-3.51-.76-6.96-1.14-10.34-1.14-8.07,0-15.34,1.4-21.83,4.21-6.49,2.8-12.01,6.66-16.57,11.57-4.56,4.91-8.07,10.7-10.52,17.36-2.46,6.66-3.68,13.85-3.68,21.57s1.23,14.9,3.68,21.57c2.45,6.66,5.96,12.45,10.52,17.36,4.56,4.91,10.08,8.77,16.57,11.57,6.49,2.81,13.76,4.21,21.83,4.21,6.66,0,12.92-.53,18.76-1.58,5.84-1.05,11.16-2.98,15.96-5.79v-41.73h-29.81v-10.52h41.38v58.91Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m650.33,214.76c-4.09,6.2-9.15,10.64-15.17,13.33-6.02,2.69-12.65,4.03-19.9,4.03-6.2,0-11.81-1.05-16.83-3.16-5.03-2.1-9.35-5.05-12.97-8.85-3.62-3.8-6.4-8.3-8.33-13.5-1.93-5.2-2.89-10.96-2.89-17.27s.99-11.69,2.98-16.83c1.99-5.14,4.79-9.61,8.42-13.41,3.62-3.8,7.89-6.78,12.8-8.94,4.91-2.16,10.34-3.24,16.31-3.24s11.66,1.08,16.39,3.24c4.73,2.17,8.71,5.03,11.92,8.59,3.21,3.57,5.64,7.63,7.28,12.19,1.64,4.56,2.45,9.18,2.45,13.85v7.36h-68.03c0,2.22.44,5.06,1.31,8.5.88,3.45,2.48,6.81,4.82,10.08,2.34,3.27,5.46,6.08,9.38,8.42,3.92,2.34,8.97,3.51,15.17,3.51,5.38,0,10.58-1.28,15.6-3.86,5.02-2.57,8.88-6.08,11.57-10.52l7.71,6.49Zm-8.07-32.09c0-3.62-.73-7.01-2.19-10.17-1.46-3.16-3.45-5.93-5.96-8.33-2.51-2.39-5.5-4.3-8.94-5.7-3.45-1.4-7.1-2.1-10.96-2.1-5.73,0-10.49,1.17-14.29,3.51-3.8,2.34-6.81,5.03-9.03,8.07-2.22,3.04-3.8,5.99-4.73,8.85-.94,2.87-1.4,4.82-1.4,5.87h57.51Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m672.65,171.8c0-1.52-.06-3.36-.17-5.52-.12-2.16-.21-4.35-.26-6.58-.06-2.22-.15-4.29-.26-6.22-.12-1.93-.17-3.42-.17-4.47h10.52c.12,3.04.2,5.96.26,8.77.06,2.81.2,4.62.44,5.44h.53c2.1-4.44,5.61-8.27,10.52-11.48,4.91-3.21,10.63-4.82,17.18-4.82s11.45.99,15.43,2.98c3.97,1.99,7.1,4.59,9.38,7.8,2.28,3.22,3.86,6.93,4.73,11.13.88,4.21,1.31,8.53,1.31,12.97v48.22h-10.52v-47.69c0-3.27-.29-6.46-.88-9.56-.59-3.1-1.61-5.87-3.07-8.33-1.46-2.46-3.51-4.41-6.14-5.87-2.63-1.46-6.05-2.19-10.26-2.19-3.86,0-7.51.67-10.96,2.02-3.45,1.34-6.43,3.39-8.94,6.14-2.52,2.75-4.5,6.2-5.96,10.34-1.46,4.15-2.19,9.03-2.19,14.64v40.5h-10.52v-58.21Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m766.89,149.01h10.52v81h-10.52v-81Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m871.25,207.22c0,1.52.06,3.36.17,5.52.12,2.16.2,4.36.26,6.58.06,2.22.15,4.3.26,6.22.12,1.93.17,3.42.17,4.47h-10.52c-.12-3.04-.21-5.96-.26-8.77-.06-2.81-.21-4.62-.44-5.44h-.53c-2.1,4.44-5.61,8.27-10.52,11.48-4.91,3.21-10.64,4.82-17.18,4.82s-11.48-1-15.52-2.98c-4.03-1.99-7.19-4.59-9.47-7.8-2.28-3.21-3.83-6.93-4.65-11.13-.82-4.21-1.23-8.53-1.23-12.97v-48.22h10.52v47.69c0,3.27.29,6.46.88,9.56.58,3.1,1.61,5.87,3.07,8.33,1.46,2.46,3.51,4.41,6.14,5.87,2.63,1.46,6.05,2.19,10.26,2.19,3.86,0,7.51-.67,10.96-2.02,3.45-1.34,6.43-3.39,8.94-6.14,2.51-2.74,4.5-6.19,5.96-10.34,1.46-4.15,2.19-9.03,2.19-14.64v-40.5h10.52v58.21Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m897.52,209.32c2.22,4.33,5.49,7.63,9.82,9.91,4.32,2.28,8.88,3.42,13.68,3.42,2.22,0,4.44-.35,6.66-1.05,2.22-.7,4.21-1.69,5.96-2.98,1.75-1.29,3.18-2.83,4.3-4.65,1.11-1.81,1.67-3.88,1.67-6.22,0-3.74-1.2-6.54-3.59-8.42-2.4-1.87-5.35-3.33-8.85-4.38-3.51-1.05-7.36-1.96-11.57-2.72-4.21-.76-8.07-1.93-11.57-3.51s-6.46-3.77-8.85-6.58c-2.4-2.81-3.59-6.78-3.59-11.92,0-3.97.82-7.42,2.46-10.34,1.64-2.92,3.77-5.35,6.4-7.28,2.63-1.93,5.58-3.36,8.85-4.3,3.27-.93,6.6-1.4,9.99-1.4,6.66,0,12.42,1.23,17.27,3.68,4.85,2.46,8.62,6.31,11.31,11.57l-9.47,5.61c-1.99-3.74-4.47-6.57-7.45-8.5s-6.87-2.89-11.66-2.89c-1.87,0-3.83.29-5.87.88-2.05.59-3.89,1.4-5.52,2.45-1.64,1.05-3.01,2.4-4.12,4.03-1.11,1.64-1.67,3.51-1.67,5.61,0,3.62,1.2,6.31,3.59,8.07,2.39,1.75,5.35,3.13,8.85,4.12,3.51,1,7.36,1.84,11.57,2.54s8.07,1.84,11.57,3.42,6.46,3.86,8.85,6.84c2.39,2.98,3.59,7.22,3.59,12.71,0,4.21-.79,7.86-2.37,10.96-1.58,3.1-3.74,5.7-6.49,7.8-2.75,2.1-5.87,3.68-9.38,4.73-3.51,1.05-7.19,1.58-11.05,1.58-7.01,0-13.41-1.35-19.2-4.03s-10.26-6.84-13.41-12.45l9.29-6.31Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m866.84,86.83l28-30.2c-.42-.3-.81-.65-1.14-1.05l-28,30.2c.43.29.82.64,1.14,1.05Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m795.11,100.76c.23.47.37.97.43,1.5l17.83-5.13c-.25-.46-.4-.97-.43-1.5l-17.83,5.13Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m823.62,45.69c-.43-.29-.82-.63-1.17-1.02l-19.24,22.06c.43.29.82.63,1.17,1.02l19.24-22.06Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m861.16,85.5l-29.28-40.41c-.38.35-.8.66-1.26.91l29.28,40.41c.37-.38.79-.68,1.26-.91Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m820.92,38.63l-33.96-4.17v.05c0,.51-.06,1.01-.19,1.5l33.96,4.16c0-.53.07-1.04.19-1.54Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m863.97,85.09v-46.47c-.5.09-1.02.09-1.53,0l-.02,46.47c.51-.09,1.04-.09,1.55,0Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m859.04,87.65l-53.22-15.05c-.08.51-.22,1.02-.42,1.49l53.22,15.04c.06-.52.2-1.02.42-1.49Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m858.6,89.4l-38.62,4.65c.17.42.25.88.25,1.34,0,.07,0,.13,0,.2l38.56-4.64c-.13-.42-.19-.86-.19-1.31,0-.08,0-.15,0-.23Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m777.88,117c.43.28.83.62,1.18,1l9.68-11.37c-.45-.27-.85-.61-1.18-1.01l-9.67,11.37Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m889.18,23.83l-21.78-14.77c-.21.47-.51.9-.87,1.28l21.78,14.77c.21-.47.51-.9.87-1.28Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m748.89,24.13c.33.41.58.86.75,1.35l27.73-15.44c-.33-.41-.58-.86-.75-1.35l-27.73,15.45Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m744.64,31.56c-.52-.07-1.02-.24-1.48-.48l-5.12,15.72c.52.07,1.02.23,1.48.48l5.12-15.73Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m775.3,32.53l-25.39-5.34c-.02.52-.13,1.03-.32,1.52l25.39,5.34c.04-.52.15-1.03.32-1.52Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m800,13.28c-.35-.4-.66-.85-.91-1.33l-14.87,17.51c.43.28.83.62,1.18,1l14.6-17.19Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m797.88,66.07l-13.53-26.61c-.43.29-.9.53-1.39.71l13.53,26.61c.43-.29.9-.53,1.39-.71Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m834.34,11.33l-6,22.3c.52.08,1.02.21,1.5.4l6-22.3c-.52-.05-1.03-.19-1.5-.4Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m892.7,49.95c.17-.49.41-.96.7-1.38l-25.8-13.11c-.15.5-.39.96-.7,1.38l25.8,13.11Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m892.75,31.6l3.4,14.81c.5-.19,1.01-.31,1.51-.35l-3.4-14.8c-.48.2-.99.32-1.51.35Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m858.61,34.09l-24.85,4.24c.14.5.23,1.01.26,1.53l24.85-4.24c-.17-.49-.26-1-.26-1.53h0Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m840.03,9.81c-.3.43-.67.8-1.1,1.1l20.53,20.53c.3-.43.67-.8,1.1-1.1l-20.53-20.53Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m802.68,77.04l11.21,15.88c.35-.39.79-.69,1.27-.9l-11.21-15.88c-.38.35-.81.65-1.27.9Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m812.03,7.75c.21.5.35,1.02.42,1.56l19.28-1.38c-.04-.26-.07-.52-.07-.78s.02-.52.07-.78l-19.71,1.38Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m799,77.67c-.52-.08-1.02-.22-1.5-.43l-5.99,20.99c.52.05,1.03.2,1.5.42l5.99-20.99Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m754.27,89.24c-.33.4-.73.74-1.17,1.01l5.9,6.85c.31-.42.72-.76,1.17-1.01l-5.9-6.86Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m793.93,72.51c-.03-.26-.05-.52-.05-.78s.02-.52.05-.78h-25.06c.06.25.08.51.08.78s-.03.52-.08.78h25.06Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m779.37,40.3c-.5-.14-.98-.34-1.42-.6l-11.97,28.44c.51.1,1,.3,1.42.6l11.97-28.44Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m795.53,75.85c-.36-.38-.67-.8-.92-1.26l-30.28,21.99c.39.35.7.78.91,1.26l30.28-21.99Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m761.99,70.21c.22-.47.53-.89.93-1.24l-21.68-16.26c-.23.47-.54.89-.93,1.24l21.68,16.26Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m754.48,83.66l8.85-8.85c-.44-.28-.82-.66-1.1-1.1l-8.85,8.85c.43.3.8.67,1.1,1.1Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m827.38,34.51c3.14,0,5.69,2.55,5.69,5.69s-2.55,5.69-5.69,5.69-5.69-2.55-5.69-5.69,2.55-5.69,5.69-5.69m0-3.2c4.91,0,8.89,3.98,8.89,8.89s-3.98,8.89-8.89,8.89-8.89-3.98-8.89-8.89,3.98-8.89,8.89-8.89Z",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m780.96,29.46c2.79,0,5.05,2.26,5.05,5.05s-2.26,5.05-5.05,5.05-5.05-2.26-5.05-5.05,2.26-5.05,5.05-5.05m0-3.19c4.55,0,8.24,3.69,8.24,8.24s-3.69,8.24-8.24,8.24-8.24-3.69-8.24-8.24,3.69-8.24,8.24-8.24Z",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m799.88,66.68c2.79,0,5.05,2.26,5.05,5.05s-2.26,5.05-5.05,5.05-5.05-2.26-5.05-5.05,2.26-5.05,5.05-5.05m0-3.19c4.55,0,8.24,3.69,8.24,8.24s-3.69,8.24-8.24,8.24-8.24-3.69-8.24-8.24,3.69-8.24,8.24-8.24Z",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m836.27,3.51c2.01,0,3.64,1.63,3.64,3.64s-1.63,3.64-3.64,3.64-3.64-1.63-3.64-3.64,1.63-3.64,3.64-3.64m0-2.05c3.14,0,5.69,2.55,5.69,5.69s-2.55,5.69-5.69,5.69-5.69-2.55-5.69-5.69,2.55-5.69,5.69-5.69Z",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m863.19,85.98c2.01,0,3.64,1.63,3.64,3.64s-1.63,3.64-3.64,3.64-3.64-1.63-3.64-3.64,1.63-3.64,3.64-3.64m0-2.05c3.14,0,5.69,2.55,5.69,5.69s-2.55,5.69-5.69,5.69-5.69-2.55-5.69-5.69,2.55-5.69,5.69-5.69Z",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m750.72,82.67c2.01,0,3.64,1.63,3.64,3.64s-1.63,3.64-3.64,3.64-3.64-1.63-3.64-3.64,1.63-3.64,3.64-3.64m0-2.05c3.14,0,5.69,2.55,5.69,5.69s-2.55,5.69-5.69,5.69-5.69-2.55-5.69-5.69,2.55-5.69,5.69-5.69Z",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m761.9,96.61c1.49,0,2.7,1.21,2.7,2.7s-1.21,2.7-2.7,2.7-2.7-1.21-2.7-2.7,1.21-2.7,2.7-2.7m0-1.51c2.33,0,4.21,1.88,4.21,4.21s-1.88,4.21-4.21,4.21-4.21-1.88-4.21-4.21,1.88-4.21,4.21-4.21Z",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m863.21,3.51c2.01,0,3.64,1.63,3.64,3.64s-1.63,3.64-3.64,3.64-3.64-1.63-3.64-3.64,1.63-3.64,3.64-3.64m0-2.05c3.14,0,5.69,2.55,5.69,5.69s-2.55,5.69-5.69,5.69-5.69-2.55-5.69-5.69,2.55-5.69,5.69-5.69Z",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m892.5,23.37c2.01,0,3.64,1.63,3.64,3.64s-1.63,3.64-3.64,3.64-3.64-1.63-3.64-3.64,1.63-3.64,3.64-3.64m0-2.05c3.14,0,5.69,2.55,5.69,5.69s-2.55,5.69-5.69,5.69-5.69-2.55-5.69-5.69,2.55-5.69,5.69-5.69Z",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m898.2,47c2.69,0,4.87,2.18,4.87,4.87s-2.18,4.87-4.87,4.87-4.87-2.18-4.87-4.87,2.18-4.87,4.87-4.87m0-2.74c4.2,0,7.61,3.41,7.61,7.61s-3.41,7.61-7.61,7.61-7.61-3.41-7.61-7.61,3.41-7.61,7.61-7.61Z",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m816.58,92.69c1.49,0,2.7,1.21,2.7,2.7s-1.21,2.7-2.7,2.7-2.7-1.21-2.7-2.7,1.21-2.7,2.7-2.7m0-1.51c2.32,0,4.21,1.88,4.21,4.21s-1.89,4.21-4.21,4.21-4.21-1.88-4.21-4.21,1.88-4.21,4.21-4.21Z",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m791.04,99.16c1.97,0,3.57,1.6,3.57,3.57s-1.6,3.57-3.57,3.57-3.57-1.6-3.57-3.57,1.6-3.57,3.57-3.57m0-2.01c3.08,0,5.58,2.5,5.58,5.58s-2.5,5.58-5.58,5.58-5.58-2.5-5.58-5.58,2.5-5.58,5.58-5.58Z",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m745.31,23.37c2.01,0,3.64,1.63,3.64,3.64s-1.63,3.64-3.64,3.64-3.64-1.63-3.64-3.64,1.63-3.64,3.64-3.64m0-2.05c3.14,0,5.69,2.55,5.69,5.69s-2.55,5.69-5.69,5.69-5.69-2.55-5.69-5.69,2.55-5.69,5.69-5.69Z",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m780.96,3.51c2.01,0,3.64,1.63,3.64,3.64s-1.63,3.64-3.64,3.64-3.64-1.63-3.64-3.64,1.63-3.64,3.64-3.64m0-2.05c3.14,0,5.69,2.55,5.69,5.69s-2.55,5.69-5.69,5.69-5.69-2.55-5.69-5.69,2.55-5.69,5.69-5.69Z",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m737.53,47.31c1.98,0,3.59,1.61,3.59,3.59s-1.61,3.59-3.59,3.59-3.59-1.61-3.59-3.59,1.61-3.59,3.59-3.59m0-2.02c3.1,0,5.61,2.51,5.61,5.61s-2.51,5.61-5.61,5.61-5.61-2.51-5.61-5.61,2.51-5.61,5.61-5.61Z",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m765.31,69.03c1.49,0,2.7,1.21,2.7,2.7s-1.21,2.7-2.7,2.7-2.7-1.21-2.7-2.7,1.21-2.7,2.7-2.7m0-1.51c2.32,0,4.21,1.88,4.21,4.21s-1.88,4.21-4.21,4.21-4.21-1.88-4.21-4.21,1.88-4.21,4.21-4.21Z",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m863.21,30.45c2.01,0,3.64,1.63,3.64,3.64s-1.63,3.64-3.64,3.64-3.64-1.63-3.64-3.64,1.63-3.64,3.64-3.64m0-2.05c3.14,0,5.69,2.55,5.69,5.69s-2.55,5.69-5.69,5.69-5.69-2.55-5.69-5.69,2.55-5.69,5.69-5.69Z",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m804.99,3.2c3.14,0,5.69,2.55,5.69,5.69s-2.55,5.69-5.69,5.69-5.69-2.55-5.69-5.69,2.55-5.69,5.69-5.69m0-3.2c4.91,0,8.89,3.98,8.89,8.89s-3.98,8.89-8.89,8.89-8.89-3.98-8.89-8.89,3.98-8.89,8.89-8.89Z",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m577.14,263.99h2.4v3.24h.08c.37-.64.84-1.19,1.4-1.66.56-.47,1.17-.85,1.82-1.16s1.34-.53,2.06-.68c.72-.15,1.43-.22,2.12-.22,1.41,0,2.71.24,3.9.72,1.19.48,2.21,1.15,3.08,2.02.87.87,1.54,1.89,2.02,3.08.48,1.19.72,2.49.72,3.9s-.24,2.71-.72,3.9c-.48,1.19-1.15,2.21-2.02,3.08-.87.87-1.89,1.54-3.08,2.02-1.19.48-2.49.72-3.9.72-.69,0-1.4-.07-2.12-.22-.72-.15-1.41-.37-2.06-.68s-1.26-.69-1.82-1.16c-.56-.47-1.03-1.02-1.4-1.66h-.08v12.36h-2.4v-27.6Zm2.16,9.24c0,1.04.2,2.02.6,2.94.4.92.95,1.72,1.64,2.4.69.68,1.51,1.22,2.44,1.62.93.4,1.95.6,3.04.6s2.13-.2,3.04-.6c.91-.4,1.68-.94,2.32-1.62.64-.68,1.13-1.48,1.46-2.4.33-.92.5-1.9.5-2.94s-.17-2.02-.5-2.94c-.33-.92-.82-1.72-1.46-2.4s-1.41-1.22-2.32-1.62c-.91-.4-1.92-.6-3.04-.6s-2.11.2-3.04.6c-.93.4-1.75.94-2.44,1.62s-1.24,1.48-1.64,2.4c-.4.92-.6,1.9-.6,2.94Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m600.68,273.23c0-1.41.24-2.71.72-3.9.48-1.19,1.15-2.21,2-3.08s1.88-1.54,3.08-2.02c1.2-.48,2.51-.72,3.92-.72s2.71.24,3.9.72c1.19.48,2.21,1.15,3.08,2.02.87.87,1.54,1.89,2.02,3.08.48,1.19.72,2.49.72,3.9s-.24,2.71-.72,3.9c-.48,1.19-1.15,2.21-2.02,3.08-.87.87-1.89,1.54-3.08,2.02-1.19.48-2.49.72-3.9.72s-2.72-.24-3.92-.72c-1.2-.48-2.23-1.15-3.08-2.02s-1.52-1.89-2-3.08c-.48-1.19-.72-2.49-.72-3.9Zm2.4,0c0,1.04.17,2.02.5,2.94.33.92.82,1.72,1.46,2.4.64.68,1.41,1.22,2.32,1.62.91.4,1.92.6,3.04.6s2.13-.2,3.04-.6c.91-.4,1.68-.94,2.32-1.62.64-.68,1.13-1.48,1.46-2.4.33-.92.5-1.9.5-2.94s-.17-2.02-.5-2.94c-.33-.92-.82-1.72-1.46-2.4-.64-.68-1.41-1.22-2.32-1.62-.91-.4-1.92-.6-3.04-.6s-2.13.2-3.04.6c-.91.4-1.68.94-2.32,1.62-.64.68-1.13,1.48-1.46,2.4-.33.92-.5,1.9-.5,2.94Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m622.25,263.99h2.64l4.48,15.48h.08l5.16-15.48h2.28l5.48,15.48h.08l4.36-15.48h2.4l-5.44,18.48h-2.48l-5.52-15.12h-.08l-5.16,15.12h-2.48l-5.8-18.48Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m668.84,278.99c-.93,1.41-2.09,2.43-3.46,3.04-1.37.61-2.89.92-4.54.92-1.41,0-2.69-.24-3.84-.72-1.15-.48-2.13-1.15-2.96-2.02s-1.46-1.89-1.9-3.08c-.44-1.19-.66-2.5-.66-3.94s.23-2.67.68-3.84c.45-1.17,1.09-2.19,1.92-3.06s1.8-1.55,2.92-2.04,2.36-.74,3.72-.74,2.66.25,3.74.74,1.99,1.15,2.72,1.96c.73.81,1.29,1.74,1.66,2.78.37,1.04.56,2.09.56,3.16v1.68h-15.52c0,.51.1,1.15.3,1.94.2.79.57,1.55,1.1,2.3.53.75,1.25,1.39,2.14,1.92.89.53,2.05.8,3.46.8,1.23,0,2.41-.29,3.56-.88,1.15-.59,2.03-1.39,2.64-2.4l1.76,1.48Zm-1.84-7.32c0-.83-.17-1.6-.5-2.32s-.79-1.35-1.36-1.9c-.57-.55-1.25-.98-2.04-1.3-.79-.32-1.62-.48-2.5-.48-1.31,0-2.39.27-3.26.8-.87.53-1.55,1.15-2.06,1.84-.51.69-.87,1.37-1.08,2.02-.21.65-.32,1.1-.32,1.34h13.12Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m674.36,269.19c0-.35-.01-.77-.04-1.26-.03-.49-.05-.99-.06-1.5-.01-.51-.03-.98-.06-1.42-.03-.44-.04-.78-.04-1.02h2.4c.03.69.05,1.36.06,2,.01.64.05,1.05.1,1.24.61-1.09,1.4-1.99,2.36-2.68s2.13-1.04,3.52-1.04c.24,0,.47.02.7.06s.46.09.7.14l-.28,2.36c-.32-.11-.63-.16-.92-.16-1.04,0-1.94.17-2.7.5-.76.33-1.39.79-1.88,1.38s-.86,1.27-1.1,2.06c-.24.79-.36,1.63-.36,2.54v10.08h-2.4v-13.28Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m703.11,278.99c-.93,1.41-2.09,2.43-3.46,3.04-1.37.61-2.89.92-4.54.92-1.41,0-2.69-.24-3.84-.72-1.15-.48-2.13-1.15-2.96-2.02s-1.46-1.89-1.9-3.08c-.44-1.19-.66-2.5-.66-3.94s.23-2.67.68-3.84c.45-1.17,1.09-2.19,1.92-3.06s1.8-1.55,2.92-2.04,2.36-.74,3.72-.74,2.66.25,3.74.74,1.99,1.15,2.72,1.96c.73.81,1.29,1.74,1.66,2.78.37,1.04.56,2.09.56,3.16v1.68h-15.52c0,.51.1,1.15.3,1.94.2.79.57,1.55,1.1,2.3.53.75,1.25,1.39,2.14,1.92.89.53,2.05.8,3.46.8,1.23,0,2.41-.29,3.56-.88,1.15-.59,2.03-1.39,2.64-2.4l1.76,1.48Zm-1.84-7.32c0-.83-.17-1.6-.5-2.32s-.79-1.35-1.36-1.9c-.57-.55-1.25-.98-2.04-1.3-.79-.32-1.62-.48-2.5-.48-1.31,0-2.39.27-3.26.8-.87.53-1.55,1.15-2.06,1.84-.51.69-.87,1.37-1.08,2.02-.21.65-.32,1.1-.32,1.34h13.12Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m724.81,279.23h-.08c-.37.64-.84,1.19-1.4,1.66-.56.47-1.17.85-1.82,1.16s-1.34.53-2.06.68-1.43.22-2.12.22c-1.41,0-2.72-.24-3.92-.72-1.2-.48-2.23-1.15-3.08-2.02s-1.52-1.89-2-3.08c-.48-1.19-.72-2.49-.72-3.9s.24-2.71.72-3.9c.48-1.19,1.15-2.21,2-3.08s1.88-1.54,3.08-2.02c1.2-.48,2.51-.72,3.92-.72.69,0,1.4.07,2.12.22.72.15,1.41.37,2.06.68s1.26.69,1.82,1.16c.56.47,1.03,1.02,1.4,1.66h.08v-15h2.4v30.24h-2.4v-3.24Zm.24-6c0-1.04-.2-2.02-.6-2.94s-.95-1.72-1.64-2.4c-.69-.68-1.51-1.22-2.44-1.62-.93-.4-1.95-.6-3.04-.6s-2.13.2-3.04.6c-.91.4-1.68.94-2.32,1.62-.64.68-1.13,1.48-1.46,2.4-.33.92-.5,1.9-.5,2.94s.17,2.02.5,2.94c.33.92.82,1.72,1.46,2.4.64.68,1.41,1.22,2.32,1.62.91.4,1.92.6,3.04.6s2.11-.2,3.04-.6c.93-.4,1.75-.94,2.44-1.62.69-.68,1.24-1.48,1.64-2.4s.6-1.9.6-2.94Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m742.97,252.23h2.4v15h.08c.37-.64.84-1.19,1.4-1.66.56-.47,1.17-.85,1.82-1.16s1.34-.53,2.06-.68c.72-.15,1.43-.22,2.12-.22,1.41,0,2.71.24,3.9.72,1.19.48,2.21,1.15,3.08,2.02.87.87,1.54,1.89,2.02,3.08.48,1.19.72,2.49.72,3.9s-.24,2.71-.72,3.9c-.48,1.19-1.15,2.21-2.02,3.08-.87.87-1.89,1.54-3.08,2.02-1.19.48-2.49.72-3.9.72-.69,0-1.4-.07-2.12-.22-.72-.15-1.41-.37-2.06-.68s-1.26-.69-1.82-1.16c-.56-.47-1.03-1.02-1.4-1.66h-.08v3.24h-2.4v-30.24Zm2.16,21c0,1.04.2,2.02.6,2.94.4.92.95,1.72,1.64,2.4.69.68,1.51,1.22,2.44,1.62.93.4,1.95.6,3.04.6s2.13-.2,3.04-.6c.91-.4,1.68-.94,2.32-1.62.64-.68,1.13-1.48,1.46-2.4.33-.92.5-1.9.5-2.94s-.17-2.02-.5-2.94c-.33-.92-.82-1.72-1.46-2.4s-1.41-1.22-2.32-1.62c-.91-.4-1.92-.6-3.04-.6s-2.11.2-3.04.6c-.93.4-1.75.94-2.44,1.62s-1.24,1.48-1.64,2.4c-.4.92-.6,1.9-.6,2.94Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m772.22,288.19c-.45,1.2-1.08,2.15-1.88,2.84-.8.69-1.87,1.04-3.2,1.04-.4,0-.8-.03-1.2-.1-.4-.07-.79-.15-1.16-.26l.24-2.24c.35.11.7.21,1.06.3.36.09.73.14,1.1.14.43,0,.81-.09,1.14-.28.33-.19.62-.43.86-.72.24-.29.45-.62.62-.98.17-.36.33-.73.46-1.1l1.68-4.28-7.52-18.56h2.68l6.12,15.56,5.96-15.56h2.56l-9.52,24.2Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m796.38,254.15h3.84v12.24h.32l12.52-12.24h5.36l-13.68,13.08,14.6,15.24h-5.6l-13.2-14.16h-.32v14.16h-3.84v-28.32Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m822.34,254.15h5.04l15.6,23.28h.08v-23.28h3.84v28.32h-4.88l-15.76-23.28h-.08v23.28h-3.84v-28.32Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m866.71,283.19c-2.16,0-4.15-.38-5.96-1.14s-3.37-1.81-4.66-3.14c-1.29-1.33-2.31-2.91-3.04-4.72-.73-1.81-1.1-3.77-1.1-5.88s.37-4.07,1.1-5.88c.73-1.81,1.75-3.39,3.04-4.72,1.29-1.33,2.85-2.38,4.66-3.14,1.81-.76,3.8-1.14,5.96-1.14s4.15.38,5.96,1.14c1.81.76,3.37,1.81,4.66,3.14,1.29,1.33,2.31,2.91,3.04,4.72s1.1,3.77,1.1,5.88-.37,4.07-1.1,5.88c-.73,1.81-1.75,3.39-3.04,4.72-1.29,1.33-2.85,2.38-4.66,3.14s-3.8,1.14-5.96,1.14Zm0-3.6c1.63,0,3.09-.3,4.4-.9,1.31-.6,2.43-1.41,3.36-2.42.93-1.01,1.65-2.21,2.16-3.58.51-1.37.76-2.83.76-4.38s-.25-3.01-.76-4.38c-.51-1.37-1.23-2.57-2.16-3.58-.93-1.01-2.05-1.82-3.36-2.42s-2.77-.9-4.4-.9-3.09.3-4.4.9c-1.31.6-2.43,1.41-3.36,2.42-.93,1.01-1.65,2.21-2.16,3.58-.51,1.37-.76,2.83-.76,4.38s.25,3.01.76,4.38c.51,1.37,1.23,2.57,2.16,3.58.93,1.01,2.05,1.82,3.36,2.42,1.31.6,2.77.9,4.4.9Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m882.59,254.15h4l6.26,22.64h.08l6.66-22.64h4.4l6.66,22.64h.08l6.26-22.64h4l-8.24,28.32h-4.08l-6.84-23.12h-.08l-6.8,23.12h-4.08l-8.28-28.32Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m924.29,254.15h5.04l15.6,23.28h.08v-23.28h3.84v28.32h-4.88l-15.76-23.28h-.08v23.28h-3.84v-28.32Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m953.72,259.37c0-.84.16-1.62.48-2.36s.76-1.38,1.31-1.93c.55-.55,1.19-.99,1.93-1.31.73-.32,1.52-.48,2.36-.48s1.62.16,2.36.48c.73.32,1.38.76,1.93,1.31s.99,1.19,1.31,1.93c.32.73.48,1.52.48,2.36s-.16,1.62-.48,2.36c-.32.73-.76,1.38-1.31,1.93-.55.55-1.19.98-1.93,1.31-.73.32-1.52.48-2.36.48s-1.62-.16-2.36-.48c-.73-.32-1.38-.76-1.93-1.31-.55-.55-.98-1.19-1.31-1.93s-.48-1.52-.48-2.36Zm.88,0c0,.72.14,1.39.41,2.02.27.63.64,1.18,1.11,1.65s1.02.84,1.65,1.11c.63.27,1.31.41,2.02.41s1.39-.14,2.02-.41c.63-.27,1.18-.64,1.65-1.11s.84-1.02,1.11-1.65c.27-.63.41-1.31.41-2.02s-.14-1.39-.41-2.02c-.27-.63-.64-1.18-1.11-1.65s-1.02-.84-1.65-1.11-1.31-.41-2.02-.41-1.39.14-2.02.41c-.63.27-1.18.64-1.65,1.11s-.84,1.02-1.11,1.65c-.27.63-.41,1.31-.41,2.02Zm3.87,3.48h-.88v-7h2.69c.79,0,1.36.17,1.7.5.34.33.51.81.51,1.44,0,.33-.05.6-.14.83-.09.23-.22.42-.38.58-.16.16-.35.28-.56.38-.21.09-.44.16-.68.2l2.09,3.07h-1l-2.09-3.07h-1.26v3.07Zm0-3.85h1.13c.24,0,.48,0,.72-.02s.45-.07.64-.15c.19-.08.35-.2.47-.36.12-.16.18-.38.18-.68,0-.23-.05-.42-.14-.56-.09-.15-.21-.26-.36-.35-.15-.09-.32-.15-.51-.19s-.38-.06-.56-.06h-1.57v2.37Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "KNOWN-NODE"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m772.73,116.1v.1c-.01.58.43,1.07,1.01,1.12,3.89.33,7.11,2.85,8.35,6.5-1.22.61-2.04,1.87-2.06,3.27-.03,2.05,1.61,3.74,3.66,3.76s3.74-1.62,3.76-3.66c.03-1.86-1.34-3.43-3.13-3.72-1.42-4.63-5.54-7.97-10.4-8.38-.3-.03-.59.07-.82.26-.22.19-.36.45-.39.74Zm12.5,11.06c-.01.82-.69,1.48-1.5,1.46s-1.48-.69-1.47-1.51.69-1.48,1.51-1.46,1.48.69,1.46,1.51Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m770.38,138.83c.73.19,1.47.3,2.19.35,4.17.26,8.1-1.63,10.51-5.06.17-.25.24-.54.19-.84-.05-.29-.22-.55-.46-.72-.24-.17-.54-.24-.83-.18-.29.05-.55.21-.72.46-1.96,2.78-5.16,4.32-8.55,4.11-.49-.03-.98-.1-1.48-.21,0-.02,0-.04,0-.06.13-2.04-1.43-3.81-3.48-3.93-2.04-.13-3.81,1.44-3.94,3.48-.13,2.04,1.44,3.81,3.48,3.93,1.19.07,2.32-.43,3.08-1.33Zm-4.33-2.47c.05-.82.76-1.44,1.57-1.39.82.05,1.44.76,1.39,1.57s-.76,1.44-1.57,1.39-1.44-.76-1.39-1.57Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m763.89,130.59h0c-.47-1.19-.7-2.44-.69-3.72.03-2.36.95-4.66,2.54-6.41.6.42,1.31.65,2.06.66,2.05.03,3.73-1.61,3.76-3.66.03-2.05-1.61-3.74-3.66-3.76s-3.74,1.62-3.76,3.66c0,.45.07.9.23,1.32-2.12,2.18-3.34,5.13-3.39,8.16-.02,1.58.26,3.12.84,4.57.11.28.32.5.6.61.27.12.57.12.85.01.57-.23.85-.88.62-1.45Zm5.44-13.17c-.01.82-.69,1.48-1.51,1.46s-1.48-.69-1.46-1.51.69-1.48,1.5-1.46,1.48.69,1.47,1.51Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWhite);
export default __webpack_public_path__ + "static/media/logo-white.4daa1ee04678407dac00e8ec7bb55372.svg";
export { ForwardRef as ReactComponent };